import { useMemo } from 'react';

import { ufoEventGraphQLSubscriptionSetup } from '@/components/signup/utils/ufo-events';

import { useApolloClient } from './useApolloClient';

type UseGraphQlSubscriptionOptions = {
	readonly reactComponent: string;
	readonly subscriptionQuery: string;
	readonly skip: boolean;
	readonly orchestrationId?: string;
	readonly onErrorCb?: (error: unknown) => void;
};

export const useGraphQlSubscription = (options: UseGraphQlSubscriptionOptions) => {
	const { subscriptionQuery, skip, orchestrationId, onErrorCb } = options;
	const { useSubscription, gql } = useApolloClient();

	const SUBSCRIPTION_MEMO = useMemo(
		() => gql`
			${subscriptionQuery}
		`,
		[subscriptionQuery],
	);

	const { data, loading, error } = useSubscription(SUBSCRIPTION_MEMO, {
		skip,
		variables: { orchestrationId },
		// https://www.apollographql.com/docs/react/data/subscriptions/#subscriptionhookoptions-interface-oncomplete
		// https://www.apollographql.com/docs/react/data/subscriptions/#subscriptionhookoptions-interface-onerror
		onError: (subscriptionError: unknown) => {
			// SLO "bad event" for GraphQL subscription
			ufoEventGraphQLSubscriptionSetup.failure({
				error: subscriptionError,
				customData: {
					reactComponent: 'SignupProvisioningContextProvider GraphQL',
					analyticsEvent: 'errored',
					errorOrigin: 'useSubscription.onError',
					orchestrationId,
				},
			});
			onErrorCb?.(subscriptionError);
		},
	});
	return { data, loading, error };
};
